import { isBrowser } from "./is-browser";

export const getPlatform = () => {
  const userAgent = isBrowser() ? navigator.userAgent : '';

  if (/Tablet|iPad/i.test(userAgent)) {
    return 'tablet-web';
  }
  if (/Mobile|iPhone|Android/i.test(userAgent)) {
    return 'mobile-web';
  }
  return 'desktop-web';
};
